class ModelNotFoundError extends Error {
    constructor(message, statusCode) {
        super(message);
        this.name = 'ModelNotFound';
        this.statusCode = statusCode;
    }
}

export default ModelNotFoundError;
